// @ts-check
import React, { useContext } from "react";
import { Context as AdminContext } from "@components/ui-builder/admin-context";
import { Trivias as TriviasBase, useTrivias } from "mibaby-frontend/trivia";
import * as placeholder from "mibaby-frontend/trivia/positions";

const NoopComponent = props =>
  React.Children.count(props.children) > 0 ? <>{props.children}</> : null;

const Trivias = props => (!useContext(AdminContext) ? <TriviasBase {...props} /> : null);

/**
 * teaser structure template, which allows placement of trivias at common positions
 *
 * @see mibaby-frontend/trivia/positions
 *
 * @param {{
 *  trivias: import("mibaby-frontend/trivia/util").CommonTriviaProps[]
 *  elements: object,
 *  Wrapper: React.ComponentType<any>,
 *  Content: React.ComponentType<any>
 * }} param0
 *
 * @todo Implement all TriviaComponent placeholders. @see m_b_ph.php
 */
const Template = ({
  elements: { title, body, asset } = {},
  Wrapper = NoopComponent,
  Content = NoopComponent,
  ...props
}) => {
  const groups = useTrivias(props.trivias);

  return (
    <>
      <Trivias position={placeholder.CONTAINER_BEGIN} groups={groups} />
      <Wrapper {...props}>
        <Trivias position={placeholder.CONTAINER_TRIVIA_BEGIN} groups={groups}>
          <div className="trivia-begin list-group" />
        </Trivias>
        <Content {...props}>
          {asset}
          {title}
          {body}
        </Content>
        <Trivias position={placeholder.CONTAINER_END} groups={groups}>
          <div className="trivia-end list-group" />
        </Trivias>
      </Wrapper>
      <Trivias position={placeholder.CONTAINER_AFTER} groups={groups} />
    </>
  );
};

export default Template;
